module.exports = __webpack_public_path__ + "static/media/championIcon.a1a9405f.svg";